import apiClient from "../api/apiClient";   // ✅ ADD THIS LINE

export const getAttendanceStudents = async (payload) => {
  const res = await apiClient.post("/v1/attendance/students", payload);
  return res.data;
};

export const submitAttendance = async (payload) => {
  const res = await apiClient.post("/v1/attendance/submit", payload);
  return res.data;
};

export const getAttendanceReport = async (payload) => {
  const res = await apiClient.post("/v1/attendance/report", payload);
  return res.data;
};
